import React, { Component } from "react";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  FormItem,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarCndDs } from "../../DataSources";
import showReport from "../../showReport";

const localStorageKey = "cadastroCndGridState";

let ano = new Date();

export default class CertidaoNegativaBox extends Component {
  constructor() {
    super();

    this.state = {
      filtroCorrente: [],
      filtro: {
        exercicio: ano.getFullYear(),
        nome: "",
        imovel: undefined,
        natureza: -1,
        tipoCadastro: -1,
        status: -1,
        cpfCnpj: "",
        dataInicial: undefined,
        dataFinal: undefined,
      },
    };

    this._gridInstance = React.createRef();
    this._formInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.cndDs = criarCndDs();
    this.filtrar = this.filtrar.bind(this);
    this.clearFilter = this.clearFilter.bind(this);

    this.naturezaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: -1, descricao: "Todos" },
        { id: "N", descricao: "Negativa" },
        { id: "P", descricao: "Positiva" },
      ],
      displayExpr: "descricao",
      valueExpr: "id",
    };

    this.tipoCadastroOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: -1, descricao: "Todos" },
        { id: "C", descricao: "Contribuinte" },
        { id: "I", descricao: "Imóvel" },
        { id: "E", descricao: "Empresa" },
      ],
      displayExpr: "descricao",
      valueExpr: "id",
    };

    this.statusOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: -1, descricao: "Todos" },
        { id: 0, descricao: "Normal" },
        { id: 1, descricao: "Cancelada" },
      ],
      displayExpr: "descricao",
      valueExpr: "id",
    };
  }

  clearFilter() {
    this.setState({
      filtro: { natureza: -1, tipoCadastro: -1, status: -1 },
    });
    this.filtrar();
    this._formInstance.instance.repaint();
  }

  filtrar(e) {
    let filtro = this.state.filtro;
    console.log(filtro);

    let filtroCorrente = [];

    if (filtro.dataInicial != undefined) {
      const data = filtro.dataInicial;
      filtroCorrente.push([
        "data",
        ">=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          0,
          0,
          0,
          0
        ),
      ]);

    }

    if (filtro.dataFinal != undefined) {
      const data = filtro.dataFinal;
      filtroCorrente.push([
        "data",
        "<=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          23,
          59,
          59,
          999
        ),
      ]);
    }

    if (filtro.natureza && filtro.natureza !== -1) {
      filtroCorrente.push([
        "tipoDeCertidao.naturezaStr",
        "=",
        filtro.natureza.trim(),
      ]);
    }

    if (filtro.status && filtro.status !== -1) {
      filtroCorrente.push(["status", "=", filtro.status]);
    }

    if (filtro.tipoCadastro && filtro.tipoCadastro !== -1) {
      filtroCorrente.push(["tipoDeCertidao.tipoCadastroStr", "=", filtro.tipoCadastro.trim()]);

      if (filtro.inscricao && filtro.tipoCadastro.trim() == "C") {
        filtroCorrente.push(["contribuinte.sequencial", "=", filtro.inscricao]);
      }
      else if (filtro.inscricao && filtro.tipoCadastro.trim() == "I") {
        filtroCorrente.push(["imovel.sequencial", "=", filtro.inscricao]);
      }
      else if (filtro.inscricao && filtro.tipoCadastro.trim() == "C") {
        filtroCorrente.push(["cpbs.inscricao", "=", filtro.inscricao]);
      }

    }

    if (filtro.inscricao && filtro.inscricao !== "" && filtro.tipoCadastro == -1) {
      var filtroInscricao = []
      filtroInscricao.push(["imovel.sequencial", "=", filtro.inscricao.trim()]);
      filtroInscricao.push("or");
      filtroInscricao.push(["contribuinte.sequencial", "=", filtro.inscricao.trim()]);
      filtroInscricao.push("or");
      filtroInscricao.push(["cpbs.inscricao", "=", filtro.inscricao.trim()]);

      filtroCorrente.push(filtroInscricao);
    }
    if (filtro.cpfCnpj && filtro.cpfCnpj !== "") {
      const cpfCnpj = filtro.cpfCnpj.replace(/\D/g, "");
      filtroCorrente.push([
        "contribuinte.cpfCnpj",
        "=",
        cpfCnpj,
      ]);
    }






    if (filtro.nome && filtro.nome !== "") {
      filtroCorrente.push([
        "contribuinte.nome",
        "contains",
        filtro.nome.trim(),
      ]);
    }

    console.log(filtroCorrente);

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("certidaonegativa/editar/" + e.row.data.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form
              id="frmPesquisa"
              formData={this.state.filtro}
              colCount={4}
              labelLocation="top"
              ref={form => this._formInstance = form}
            >
              <SimpleItem
                dataField="dataInicial"
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true, showClearButton: true }}
                colSpan={1}>
                <Label text="Data Inicial" />
              </SimpleItem>

              <SimpleItem
                dataField="dataFinal"
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true, showClearButton: true }}
                colSpan={1}>
                <Label text="Data Final" />
              </SimpleItem>

              <SimpleItem
                dataField="natureza"
                colSpan={1}
                editorType={"dxSelectBox"}
                editorOptions={this.naturezaOptions}>
                <Label text="Natureza" />
              </SimpleItem>

              <SimpleItem
                dataField="status"
                colSpan={1}
                editorType={"dxSelectBox"}
                editorOptions={this.statusOptions}
              >
                <Label text="Status" />
              </SimpleItem>

              <SimpleItem
                dataField="tipoCadastro"
                colSpan={1}
                editorType={"dxSelectBox"}
                editorOptions={this.tipoCadastroOptions}>
                <Label text="Tipo de Cadastro" />
              </SimpleItem>

              <SimpleItem dataField="inscricao" colSpan={1}>
                <Label text="Inscrição" />
              </SimpleItem>

              <SimpleItem dataField="cpfCnpj" colSpan={1}>
                <Label text="CPF/CNPJ" />
              </SimpleItem>

              <SimpleItem dataField="nome" colSpan={1}>
                <Label text="Nome Contribuinte" />
              </SimpleItem>



            </Form>
            <br />
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "left",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={120}
                  text="Limpar Filtro"
                  onClick={this.clearFilter}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={190}
                  icon="exportselected"
                  text="Emissão Automática"
                  onClick={() => this.props.history.push("/certidaonegativa/automatica")}
                />
              </div>
            </div>
          </form>
          <br /> <br />
          <PaginaToolbar
            titulo="Lista de Certidões Negativas"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.cndDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              wordWrapEnabled={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
            >
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  {
                    hint: "Cancelar",
                    icon: "remove",
                    onClick: (e) => {
                      this.cndDs.remove(e.row.data.id).then(() => {
                        this._gridInstance.instance.refresh();
                      });
                    },
                  },
                  {
                    hint: "Visualizar",
                    icon: "exportpdf",
                    onClick: function (e) {
                      showReport(
                        `/report/cnd/${e.row.data.id}/${e.row.data.prefeituraId}`
                      );
                    },
                  },
                  {
                    hint: "Editar",
                    icon: "edit",
                    onClick: this.onAtualizandoRow,
                  },
                ]}
              />
              <Column
                dataField={"id"}
                caption={"#"}
                allowEditing={false}
                width={80}
                alignment={"center"}
                sortOrder={"desc"}
                sortIndex={1}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>

              <Column
                dataField={"tipoDeCertidao.tipoCadastro.descricao"}
                caption={"Tipo"}
                width={110}
              />

              <Column
                dataField={"data"}
                caption={"Emissão"}
                dataType={"date"}
                width={100}
              />

              <Column
                dataField={"statusCndStr"}
                caption={"Situação"}
                width={90}
              />

              <Column
                dataField={"numeroCompleto"}
                caption={"Número"}
                width={90}
              />

              <Column
                dataField={"dataDeValidade"}
                caption={"Validade"}
                dataType={"date"}
                width={100}
              />

              <Column
                dataField={"inscricao"}
                caption={"Inscrição"}
                width={90}
              />

              <Column
                dataField={"contribuinte.cpfCnpjFormatado"}
                caption={"CPF/CNPJ"}
                width={150}
              />

              <Column
                dataField={"contribuinte.nome"}
                caption={"Contribuinte"}
              />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment >
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("certidaonegativa/novo");
  }
}
